module.exports = __webpack_public_path__ + "img/261-2.86273c27.jpg";